import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

// Template187: Actividades y experiencias (diseño Kioto)
// 6 actividades con icono, título, descripción y enlace "Reservar aquí". Ilustración en esquina.
// Todo el contenido viene de page (backend). Colores configurables por headerBackgroundColor.
const Template187 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;
	const contentColor = textColor || "#444";

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found && found.src) return found.src;
		}
		return undefined;
	};

	const headerText = page?.texts?.[0]?.content;
	const introText = page?.texts?.[1]?.content;
	const activities = Array.isArray(page?.activities)
		? page.activities
		: Array.isArray(page?.data?.activities)
			? page.data.activities
			: Array.isArray(page?.data?.data?.activities)
				? page.data.data.activities
				: [];

	const themeColor = headerBackgroundColor || "#66A37F";
	const boxBg = "#DAE6D7";
	const boxBorder = themeColor;

	const illustrationSrc = getImageSrc("ceremonia-te");

	const h4 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "13px",
		fontWeight: 700,
		margin: "0px",
		textAlign: "left",
		color: "rgb(61, 128, 94)",
		textTransform: "uppercase",
	};

	const p = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "13px",
		color: contentColor,
		margin: "0px",
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				width: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *:not([data-template-header])": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
					color: "inherit",
				},
				"& p": { marginTop: "0px !important", marginBottom: "8px !important" },
				"& a": {
					color: themeColor,
					fontWeight: 700,
					textDecoration: "underline",
				},
			}}
		>
			{/* CABECERA */}
			{headerText && (
				<Box
					data-block-id="header"
					data-template-header
					sx={{
						backgroundColor: themeColor,
						color: "#fff!important",
						textAlign: "center",
						padding: "15px 0px",
						fontSize: "14px",
						fontWeight: 800,
						flexShrink: 0,
						position: "sticky",
						top: "0px",
						zIndex: 99999,
					}}
				>
					{headerText}
				</Box>
			)}

			{/* INTRO */}
			{introText && (
				<Box data-block-id="text-1" sx={{ padding: "16px", fontSize: "13px", color: contentColor }}>
					<Box component="p" sx={p}>
						{introText}
					</Box>
				</Box>
			)}

			{/* LISTA DE ACTIVIDADES */}
			<Box
				data-block-id="text-2"
				sx={{
					padding: "0px 16px 20px",
					display: "flex",
					flexDirection: "column",
					gap: "12px",
					position: "relative",
				}}
			>
				{activities.map((act, index) => {
					const iconSrc = act.iconId ? getImageSrc(act.iconId) : undefined;
					return (
						<Box
							key={act.title || index}
							data-block-id={`text-${index + 3}`}
							sx={{
								backgroundColor: boxBg,
								border: `3px solid #3d805e`,
								borderRadius: "12px",
								padding: "12px 14px",
								display: "flex",
								alignItems: "flex-start",
								gap: "10px",
							}}
						>
							<Box sx={{ flex: 1, minWidth: 0 }}>
								{act.title && (
									<Box
										component="h4"
										sx={{ ...h4, color: "#3d805e!important" }}
									>
										{act.title}
									</Box>
								)}
								{act.description && (
									<Box component="p" sx={{ ...p, marginBottom: "6px" }}>
										{act.description}{" "}
										{act.linkUrl && (
											<Box
												component="a"
												href={act.linkUrl}
												target="_blank"
												rel="noreferrer"
												sx={{
													fontSize: "12px",
													color: themeColor,
													fontWeight: 700,
													textDecoration: "underline",
												}}
											>
												{act.linkText || "Reservar aquí"}
											</Box>
										)}
									</Box>
								)}
							</Box>
						</Box>
					);
				})}

				{illustrationSrc && (
					<Box
						component="img"
						src={illustrationSrc}
						alt=""
						sx={{
							width: isSmallScreen ? "80px" : "100px",
							position: "absolute",
							bottom: isSmallScreen ? "-65px" : "75px",
							right: "-10px",
						}}
					/>
				)}
			</Box>
		</Box>
	);
};

Template187.thumbnail = "/images/template-1.png";

export default Template187;
